// List matches backend features list
// See app/lib/features.rb
export const CONVERSATIONS = "conversations"
export const COUNTRY_BLOCKING_FEATURE = "country_blocking"
export const METABASE_DASHBOARD_EXPORTING_FEATURE = "metabase_dashboard_exporting"
export const ORG_FORM_COPYING = "org_form_copying"
export const ORG_OPTIONS_LISTS = "org_options_lists"
export const REPORTING_FEATURE = "reporting"
export const FORM_FILE_UPLOADS_FEATURE = "form_file_uploads"
export const HELP_FEATURE = "help"
export const TASK_REPORTS = "task_reports"
